// src/pages/DetailArchive.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import toast, { Toaster } from "react-hot-toast";
import { useUserContext } from "../contexts/UserContext";
import { Blocks } from "react-loader-spinner";
import Zoom from "react-medium-image-zoom"; // si tu utilises Zoom pour la galerie
import "react-medium-image-zoom/dist/styles.css";
import { API_URL } from '../config/api';

export default function DetailArchive() {
  const { id } = useParams();
  const { user } = useUserContext();
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState(null);
  const [orders, setOrders] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showArchiveModal, setShowArchiveModal] = useState(false);

    // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  // Pagination
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentOrders = orders.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(orders.length / itemsPerPage);



  // 👇 Assure-toi d'avoir toutes les images principales et secondaires
  const allImages = product ? [product.img, ...(product.images || [])] : [];
  const getImageUrl = (img) =>
    img.startsWith("http") ? img : `${API_URL}/uploads/${img}`;

  const fetchProductDetails = async () => {
    if (!user) return;
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/products/${id}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Erreur récupération article");
      setProduct(data);
      setSelectedImage(data.img); // image principale sélectionnée par défaut
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductOrders = async () => {
    if (!user) return;
    try {
      const res = await fetch(`${API_URL}/commandes/product/${id}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Erreur récupération commandes");
      setOrders(data.commandes || []);
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  

  useEffect(() => {
    fetchProductDetails();
    fetchProductOrders();
  }, [id, user]);

const handleArchiveToggle = async () => {
  if (!product) return;

  try {
    // On choisit l'endpoint selon l'état actuel
    const endpoint = product.archived
      ? `${API_URL}/products/${product._id}/restore` // restauration
      : `${API_URL}/products/${product._id}/archive`; // archivage

    const res = await fetch(endpoint, { method: "POST" });

    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error("Réponse serveur non JSON");
    }

    if (!res.ok) throw new Error(data.message || "Action impossible");

    // Mise à jour locale sans recharger la page
    setProduct(prev => ({
      ...prev,
      archived: !prev.archived
    }));

    toast.success(
      product.archived
        ? "Produit restauré avec succès ✅"
        : "Produit archivé avec succès ✅"
    );

  } catch (err) {
    console.error(err);
    toast.error(err.message || "Erreur lors de l'opération");
  }
};


  if (loading)
    return (
      <div className="loading">
        <Blocks visible={true} height="80" width="80" />
      </div>
    );

  if (!product) return <p>Article introuvable.</p>;

  return (
    <>
      <Navbar />
      <Toaster position="top-right" />

      <div className="detail-container">
        <h1>Détails de l'article</h1>
        <div className="detail-container">
          {/* === GALERIE D'IMAGES === */}
          <div className="gallery-section">
            <div className="thumbnails">
              {allImages.map((img, i) => (
                <img
                  key={i}
                  src={getImageUrl(img)}
                  alt={`Thumbnail ${i + 1}`}
                  className={`thumbnail ${
                    selectedImage === img ? "active" : ""
                  }`}
                  onClick={() => setSelectedImage(img)}
                />
              ))}
            </div>

            <div className="main-image-container">
              {selectedImage && (
                <Zoom>
                  <img
                    src={getImageUrl(selectedImage)}
                    alt={product.title}
                    className="main-image"
                  />
                </Zoom>
              )}
            </div>
          </div>

          {/* === INFOS PRODUIT === */}
          <div className="info-section">
            <h1>{product.title}</h1>
            {product.archived && <span className="badge-archived">ARCHIVÉ</span>}
            <p className="description">{product.description}</p>
            <p>
              <strong>Catégorie :</strong> {product.categorie}
            </p>
            <p>
              <strong>Référence :</strong> {product.reference}
            </p>
            <p>
              <strong>Marque :</strong> {product.label}
            </p>

            {/* Prix avec promo */}
            <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
              {product.promotion > 0 && product.prixOriginal > 0 ? (
                <>
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "#ff4d4f",
                      fontWeight: 500,
                    }}
                  >
                    {Number(product.prixOriginal).toLocaleString()} FCFA
                  </span>
                  <span style={{ color: "#e53935", fontWeight: 700 }}>
                    Prix de vente : {Number(product.price).toLocaleString()} FCFA
                  </span>
                </>
              ) : (
                <span style={{ fontWeight: 600, fontSize: "1rem", color: "#333" }}>
                  Prix de vente :{" "}
                  {Number(product.prixOriginal > 0 ? product.prixOriginal : product.price).toLocaleString()}{" "}
                  FCFA
                </span>
              )}
            </div>

            <p>
              <strong>Prix d'achat :</strong> {product.prixAchat?.toLocaleString() || 0} FCFA
            </p>
            <p>
              <strong>Groupe :</strong> {product.groupe || "N/A"}
            </p>
            <p>
              <strong>Stock :</strong> {product.stock ?? "N/A"}
            </p>
            <p>
              <strong>Disponible :</strong> {product.disponible ? "Oui" : "Non"}
            </p>
            <p>
              <strong>Nouveauté :</strong> {product.nouveaute ? "Oui" : "Non"}
            </p>
            <p>
              <strong>Promotion :</strong> {product.promotion || 0} %
            </p>

            {/* Boutons d'action */}
            <div className="action-buttons">
              {/* <Link to={`/modifierArticle/${product._id}`}>
                <button className="btn-primary action-btn">Modifier l'article</button>
              </Link> */}

             <button
                className={`action-btn ${product.archived ? "btn-secondary" : "btn-warning"}`}
                onClick={() => setShowArchiveModal(true)}
              >
                {product.archived ? "Restaurer l'article" : "Archiver l'article"}
              </button>

              <button className="btn-danger action-btn" onClick={() => toast.info("Suppression à implémenter")}>
                Supprimer l'article
              </button>
            </div>
          </div>
        </div>

        {/* === COMMANDES ASSOCIÉES === */}
        <h2 style={{ marginTop: 40 }}>Commandes associées</h2>
        {orders.length === 0 ? (
          <p>Aucune commande pour cet article.</p>
        ) : (
         <>
          <table className="saas-table">
            <thead>
              <tr>
                <th>Numéro commande</th>
                <th>Client</th>
                <th>Quantité</th>
                <th>Total (FCFA)</th>
                <th>Statut</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order._id}>
                  <td>{order.numeroCommande || order._id}</td>
                  <td>{order.client?.name || "N/A"}</td>
                  <td>{order.cart?.reduce((acc, i) => acc + i.quantity, 0)}</td>
                  <td>
                    {order.cart
                      ?.reduce((acc, i) => acc + i.quantity * i.price, 0)
                      .toLocaleString()}
                  </td>
                  <td>{order.statut}</td>
                  <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

       
            <div style={{ marginTop: 10, display: 'flex', justifyContent: 'center', gap: 5 }}>
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Précédent
              </button>
              <span>
                Page {currentPage} / {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
              >
                Suivant
              </button>
            </div></>
        
          
        )}
      </div>

      {showArchiveModal && (
  <div className="modal-overlay">
    <div className="modal-box">
      <h3>{product.archived ? "Restaurer l'article" : "Archiver l'article"}</h3>
      <p>
        {product.archived
          ? "Voulez-vous vraiment restaurer cet article ? Il sera de nouveau disponible dans votre catalogue."
          : "Voulez-vous vraiment archiver cet article ? Il ne sera plus visible dans votre catalogue, mais pourra être restauré plus tard."}
      </p>

      <div className="modal-actions">
        <button
          className="btn-secondary"
          onClick={() => setShowArchiveModal(false)}
        >
          Annuler
        </button>

        <button
          className="btn-warning"
          onClick={async () => {
            setShowArchiveModal(false);
            await handleArchiveToggle();
          }}
        >
          {product.archived ? "Restaurer" : "Archiver"}
        </button>
      </div>
    </div>
  </div>
)}

      <Footer />


            <style>
        {
          `
          /* ================= MODAL CONFIRMATION ================= */
          .btn-danger{
          border-radius:0.7rem;
          }

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-box {
  background: #fff;
  padding: 25px 30px;
  border-radius: 12px;
  width: 420px;
  max-width: 92%;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
  animation: modalFade 0.25s ease-out;
}

.modal-box h3 {
  margin-bottom: 12px;
  font-size: 1.2rem;
}

.modal-box p {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 25px;
}

/* Animation */
@keyframes modalFade {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
  .badge-archived {
  display: inline-block;
  margin-top: 6px;
  padding: 4px 10px;
  background: #ff4d4f;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 999px;
  letter-spacing: 0.5px;
}
  /* ================= ACTION BUTTONS ================= */
.action-buttons {
  display: flex;
  gap: 12px;
  margin-top: 15px;
  flex-wrap: wrap; /* responsive */
}

.action-buttons a {
  text-decoration: none;
}

.action-btn {
  min-width: 180px;        /* 👈 même largeur */
  height: 44px;            /* 👈 même hauteur */
  padding: 0 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top:1rem
}

/* hover doux */
.action-btn:hover {
  transform: translateY(-1px);
  opacity: 0.95;
}
          `
        }
      </style>
    </>
  );
}